import Header from "./components/header";
import Footer from "./components/footer";
import { Outlet } from "react-router-dom";

const Layout = () => {
	return (
		<div className="min-h-screen bg-black text-white flex flex-col">
			<Header />
			<main className="flex-1 container mx-auto px-4 py-6">
				<Outlet />
			</main>
			<Footer />
		</div>
	);
};

export default Layout;
